export const formattedIsoToPtBrDateTime = (dateString: string): string => {
  if (!dateString) return ''

  // A base grava com +3h; exibe o horário real (-3h)
  const date = new Date(new Date(dateString).getTime() - 3 * 60 * 60 * 1000)

  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = String(date.getFullYear()).slice(-2)

  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')

  return `${day}/${month}/${year} - ${hours}:${minutes}:${seconds}`
}
